import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import { useI18n } from "vue-i18n"
import {
  ref,
  onMounted,
  onBeforeUnmount,
  computed,
} from "vue"
import { Invite } from "@/types"
import { useToast } from "vue-toast-notification"
import { doctorActions } from "@/stores/doctor-actions"


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorInviteDialog',
  props: {
    invites: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const { t } = useI18n()
const docAction = doctorActions()
const invites = ref(props.invites)
const $toast = useToast()
const smallWindow = ref(window.innerWidth < 1000)
const requestResponse = ref()

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}

onMounted(async () => {
  window.addEventListener("resize", updateWindowSize)
})

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowSize)
})

const rejectInvite = async (id: string): Promise<void> => {
  const response = await docAction.rejectHospitalInvite(id)
  requestResponse.value = response
  if (response.success) {
    $toast.success(t("invite-accept-successful"), {
      position: "bottom-left",
    })
  } else {
    $toast.error(response.message ?? "invite-accept-unsuccessful", {
      position: "bottom-left",
    })
  }
  emit("close")
}
const acceptInvite = async (id: string): Promise<void> => {
  const response = await docAction.acceptHospitalInvite(id)
  requestResponse.value = response
  if (response.success) {
    $toast.success(t("invite-accept-successful"), {
      position: "bottom-left",
    })
  } else {
    $toast.error(response.message ?? "invite-reject-unsuccessful", {
      position: "bottom-left",
    })
  }
  emit("close")
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { rounded: "lg" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center mb-5" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("hospital.invitations")), 1),
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            variant: "text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_carousel, {
        light: "",
        "hide-delimiter-background": "",
        "show-arrows": false,
        height: "auto",
        color: "black"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invites.value, (invite, index) => {
            return (_openBlock(), _createBlock(_component_v_carousel_item, { key: index }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center mb-5" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t("hospital.invitation-line")) + " " + _toDisplayString(invite.name), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(invite.name) + " " + _toDisplayString(_ctx.$t("hospital.invitation-line-1")), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("hospital.invitation-line-2")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "mb-10" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      text: _ctx.$t('hospital.reject'),
                      color: "error",
                      onClick: ($event: any) => (rejectInvite(invite._id))
                    }, null, 8, ["text", "onClick"]),
                    _createVNode(_component_v_btn, {
                      text: _ctx.$t('hospital.accept'),
                      color: "#3fb984",
                      onClick: ($event: any) => (acceptInvite(invite._id))
                    }, null, 8, ["text", "onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})